/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What data does it need?`)
};

const es_donut_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué datos necesita?`)
};

const de_donut_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Daten benötigt es?`)
};

const nl_donut_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke data heeft het nodig?`)
};

const fr_donut_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles données sont nécessaires ?`)
};

const it_donut_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che dati servono?`)
};

const pt_br2_donut_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados ele precisa?`)
};

const pt_donut_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados precisa?`)
};

const ja_donut_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのようなデータが必要ですか？`)
};

const zh_donut_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要什么数据？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_faq_q2", locale)
	if (locale === "en") return en_donut_faq_q2(inputs)
	if (locale === "es") return es_donut_faq_q2(inputs)
	if (locale === "de") return de_donut_faq_q2(inputs)
	if (locale === "nl") return nl_donut_faq_q2(inputs)
	if (locale === "fr") return fr_donut_faq_q2(inputs)
	if (locale === "it") return it_donut_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_donut_faq_q2(inputs)
	if (locale === "pt") return pt_donut_faq_q2(inputs)
	if (locale === "ja") return ja_donut_faq_q2(inputs)
	return zh_donut_faq_q2(inputs)
};